import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import EmailIcon from '@mui/icons-material/Email';
import HistoryIcon from '@mui/icons-material/History';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SentEmailsChart from '../components/SentEmailsChart';
import { api } from '../api/api';
import { StatCard, ModuleHeader } from '../../components/composed';
import { Card } from '../../components/primitives';
import { StaggerChildren, SlideUp } from '../../components/motion';

export default function Dashboard(props) {
    const theme = useTheme();
    const [countToday, setCountToday] = useState(0);
    const [countTotal, setCountTotal] = useState(0);

    useEffect(() => {
        props.setShowSearch(false);

        // Fetch both metrics in parallel
        Promise.all([
            api.history.sentToday(),
            api.history.sentTotal()
        ])
        .then(([today, total]) => {
            setCountToday(today);
            setCountTotal(total);
        })
        .catch(props.onFetchFailed);
    }, []);

    // Calculate today's percentage of total
    const todayPercentage = countTotal > 0 ? Math.round((countToday / countTotal) * 100) : 0;

    return (
        <Box>
            <ModuleHeader
                title="Dashboard"
                subtitle="Overview of email communications"
                moduleColor={theme.palette.email.main}
            />

            <StaggerChildren staggerDelay={0.1}>
                <Grid container spacing={3} sx={{ mt: 1 }}>
                    {/* Sent Today Card */}
                    <Grid item xs={12} sm={6} md={4}>
                        <StatCard
                            title="Emails Sent Today"
                            value={countToday}
                            icon={<EmailIcon />}
                            moduleColor={theme.palette.email.main}
                            delay={0}
                        />
                    </Grid>

                    {/* Sent Total Card */}
                    <Grid item xs={12} sm={6} md={4}>
                        <StatCard
                            title="Total Emails Sent"
                            value={countTotal}
                            icon={<HistoryIcon />}
                            moduleColor={theme.palette.primary.main}
                            delay={0.1}
                        />
                    </Grid>

                    {/* Today's Percentage Card */}
                    <Grid item xs={12} sm={6} md={4}>
                        <StatCard
                            title="Today's Share"
                            value={todayPercentage}
                            suffix="%"
                            icon={<TrendingUpIcon />}
                            moduleColor={theme.palette.secondary.main}
                            delay={0.2}
                        />
                    </Grid>
                </Grid>

                {/* Email History Chart */}
                <Grid container spacing={3} sx={{ mt: 2 }}>
                    <Grid item xs={12}>
                        <SlideUp delay={0.4}>
                            <Card padding={3}>
                                <Typography
                                    variant="h5"
                                    sx={{
                                        fontFamily: theme.typography.h5.fontFamily,
                                        fontWeight: 600,
                                        mb: 3,
                                        color: theme.palette.text.primary,
                                    }}
                                >
                                    Email History
                                </Typography>
                                <SentEmailsChart />
                            </Card>
                        </SlideUp>
                    </Grid>
                </Grid>
            </StaggerChildren>
        </Box>
    );
}



